/** Public ConnectyCube keys (NEXT_PUBLIC_*). Safe on client — do not mark "use server". */
export const getChatAppKeys = () => {
  return {
    CHAT_APP_ID: process.env.NEXT_PUBLIC_CHAT_APP_ID || "",
    CHAT_AUTH_KEY: process.env.NEXT_PUBLIC_CHAT_AUTH_KEY || "",
  }
}
